import { FormattedMessage } from 'react-intl'

import { useMediaQuery } from '@gto/ui/hooks/use-media-query'
import { Typography } from '@gto/ui/typography'

import { SupportLinksCard } from '@/components/support-links-card'

export const SupportRootRoute = () => {
  const isSmAndLower = useMediaQuery('down', 'sm')

  return (
    <div className="flex flex-col gap-8 sm:gap-6">
      <Typography
        gutterBottom
        component="h1"
        variant={isSmAndLower ? 'h5' : 'h4'}
      >
        <FormattedMessage id="support.title" />
      </Typography>

      <div>
        <Typography
          gutterBottom
          component="h2"
          variant="h6"
        >
          <FormattedMessage id="support.description" />
        </Typography>
        <ul>
          <li>
            <Typography variant="body1">
              <FormattedMessage id="support.propositions.1" />
            </Typography>
          </li>
          <li>
            <Typography variant="body1">
              <FormattedMessage id="support.propositions.2" />
            </Typography>
          </li>

          <li>
            <Typography variant="body1">
              <FormattedMessage id="support.propositions.3" />
            </Typography>
          </li>
        </ul>
      </div>
      <SupportLinksCard titleTKey="support.contactUs.title" />
    </div>
  )
}
